import type { MentiErrorOptions } from '@mentimeter/error-utils/error';
import { MentiError } from '@mentimeter/error-utils/error';

export class UnmigratedSlideError extends MentiError {
  constructor(options?: Partial<MentiErrorOptions> | undefined) {
    const message = 'Unmigrated slide';

    super(message, {
      feature: 'compatibility-layer',
      ...options,
    });

    this.name = 'UnmigratedSlideError';
  }
}
